import { SupportSession } from 'src/domain/support';

const SUPPORT_SESSION_KEY = 'munduSupportSession';

const getSessionStorage = (): Storage | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.sessionStorage;
};

export const supportModeService = {
    get(): SupportSession | undefined {
        const raw = getSessionStorage()?.getItem(SUPPORT_SESSION_KEY);
        if (!raw) return undefined;

        try {
            const session = JSON.parse(raw) as SupportSession;
            if (!session.token || !session.organizationId) return undefined;
            return session;
        } catch (_error) {
            return undefined;
        }
    },

    set(session: SupportSession): void {
        getSessionStorage()?.setItem(
            SUPPORT_SESSION_KEY,
            JSON.stringify(session),
        );
    },

    clear(): void {
        getSessionStorage()?.removeItem(SUPPORT_SESSION_KEY);
    },
};
